export default __webpack_public_path__ + "static/media/linkdin.2469f0b1.svg";